import React, { useState } from 'react';
import NewsFeed from '../components/NewsFeed';
import '../styles/NewsFeedPage.css';

const NewsFeedPage = ({ apiBaseUrl }) => {
  const [filters, setFilters] = useState({
    importance: '',
    update_type: '',
    start_date: '',
    end_date: '',
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="newsfeed-page">
      <h1>News Feed</h1>
      <div className="filters">
        <label>
          Importance:
          <select name="importance" value={filters.importance} onChange={handleFilterChange}>
            <option value="">All</option>
            <option value="big">Big</option>
            <option value="personal">Personal</option>
            <option value="small">Small</option>
          </select>
        </label>
        <label>
          Update Type:
          <select name="update_type" value={filters.update_type} onChange={handleFilterChange}>
            <option value="">All</option>
            <option value="steam">Steam</option>
            <option value="mal">MAL</option>
            <option value="weekly_summary">Weekly Summary</option>
          </select>
        </label>
        <label>
          Start Date:
          <input
            type="date"
            name="start_date"
            value={filters.start_date}
            onChange={handleFilterChange}
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            name="end_date"
            value={filters.end_date}
            onChange={handleFilterChange}
          />
        </label>
      </div>
      <NewsFeed apiBaseUrl={apiBaseUrl} filters={filters} />
    </div>
  );
};

export default NewsFeedPage;